module.exports = __webpack_public_path__ + "static/media/thumbnail.f620afd8.jpg";